module.exports = __webpack_public_path__ + "img/stamp2_thumb.81304197.jpg";